import { render, staticRenderFns } from "./search-popup.vue?vue&type=template&id=2bca90bc&"
import script from "./search-popup.vue?vue&type=script&lang=js&"
export * from "./search-popup.vue?vue&type=script&lang=js&"
import style0 from "./search-popup.vue?vue&type=style&index=0&id=2bca90bc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports